<h2 mat-dialog-title>Delete metadata set.</h2>
<mat-dialog-content>
  Do you wish to proceed with the deletion of metadata set: '{{setName}}'?
  All associated data will be removed.
</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>Proceed</button>
</mat-dialog-actions>
